import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Divider, Tooltip } from "@mui/material";
import "./CustomAccordian.css";
import OrderStatusCell from "./OrderStatusCell";
import { getOrderSource } from "../../features/secondaryOrder/ManageSecondaryOrderUtils";
import { ReactComponent as RedirectionIcon } from "../../assets/image/svg/redirectionIcon.svg";
import { useNavigate } from "react-router-dom";
import { GstFlagging } from "../../features/secondaryOrder/ManageSecondaryInvoice";
import { CancelledInvoiceFlagging } from "../../features/secondaryOrder/ManageSecondaryOrder";
import { truncateText } from "../../features/stocks/RealTimeStock/RealTimeStockUtils";
import { ReactComponent as EncricledDisclaimer } from "../../assets/image/svg/encircledDisclaimer.svg";
import InfoDropDown from "../../features/viewOrder/InfoDropDown";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { truncateToTwoDecimals } from "./DmsUtils";
import { Menu, MenuItem, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "./CustomAccordianV2.css"
import { ReplacementPopoverCell } from "../../features/secondaryOrder/ReplacementPopOverCell";
interface MoreDetailsSection {
  title: string;
  items: { label: string; value: string | number }[];
}
interface CustomAccordianProps {
  metaData1: CustomAccordianMetaData[];
  data1: any;
  outletApprovalData?: any;
  isCounterSaleOrder?: boolean;
  moreDetails?: MoreDetailsSection[];
  showMoreDetails?: boolean;
}

interface CustomAccordianMetaData {
  keys: string;
  label: string;
  index: number;
  valueType?: string;
  currencySymbol?: string;
  render?: string;
  removeEllipsis?: boolean;
  truncateTextAfterChar?: number; 
  valueStyle?: React.CSSProperties;
  focusField?: boolean; 
  customStyles?: any;
  onClick?: () => void;
}



const getNestedValue = (
  data: any,
  keys: string,
  valueType?: string,
  currencySymbol: string = ""
) => {
  return keys.split(".").reduce((acc, key) => {
    if (key.includes("[") && key.includes("]")) {
      const [arrayKey, index] = key.split("[");
      const idx = parseInt(index.replace("]", ""), 10);
      return (
        acc?.[arrayKey]?.[idx] ??
        (valueType?.toLowerCase() == "number" ? 0 : "-")
      );
    }

    const value = acc?.[key];
    if (valueType?.toLowerCase() === "number" && typeof value === "number") {
      return (
        currencySymbol + " " + (value % 1 !== 0 ? truncateToTwoDecimals(value) : value)
      );
    }

    return (
      currencySymbol +
      " " +
      (value ?? (valueType?.toLowerCase() == "number" ? 0 : "-"))
    );
  }, data);
};

const CustomAccordianV2 = ({
  data1,
  metaData1,
  moreDetails=[],
  showMoreDetails=true
}: CustomAccordianProps) => {

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const designationBasedUomSecondary = ConfigDictionary.designationBasedUomSecondary;

  const designationEnabled  =  designationBasedUomSecondary?.enable ?? false;
  const availableDesignations = designationBasedUomSecondary?.roles?.designationKeys?.map(((item: { type: any; }) => item?.type)) || [];
  const currentDesignation = JSON.parse(localStorage.authContext ?? "{}").user.designation || [];
  const designation = availableDesignations.find((type: any) => 
    currentDesignation.includes(type)
  );
  const designationKeys = designationBasedUomSecondary?.roles?.designationKeys ?? [];
  const matchedRole = designationKeys.find((role: { type: string; uomAllowed: any }) => role.type === designation);
  
  if(designationEnabled && designation && designationKeys && matchedRole){
    const elementToKeep = matchedRole?.uomAllowed?.case?.trim() ? "Cs" : "Pc";
    metaData1.forEach(element => {
      if (element.keys === "totalQuantities" || element.keys === "totalQuantitiesFOC_QPS"){
        element.label = `Qty (${elementToKeep})`;
      }
    });
  }
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const getFlagging = (rowData: any) => {
    if (rowData?.eInvoiced) return <GstFlagging />;
    else if (rowData?.cancelledInvoice) return <CancelledInvoiceFlagging />;
    return <></>;
  };

  const renderCustomJsx = (meta: CustomAccordianMetaData, tooltip?: boolean) => {
    const ConfigDictionary = JSON.parse(
      localStorage.getItem("ConfigDictionary") ?? "{}"
    );
    const { caseUnitLabel, otherUnitLabel, packUnitLabel } = ConfigDictionary;
    switch (meta?.keys) {
      case "totalQuantities":
        if (tooltip)
          return `
            ${caseUnitLabel ? `${data1?.totalCaseQuantity ?? 0} ${caseUnitLabel}` : ""}
            ${otherUnitLabel ? `, ${data1?.totalOtherUnitQuantity ?? 0} ${otherUnitLabel}` : ""}
            ${packUnitLabel ? `, ${data1?.totalPieceQuantity ?? 0} ${packUnitLabel}` : ""}
          `;

        if(designationEnabled && designation && designationKeys && matchedRole){
          const elementToKeep = matchedRole?.uomAllowed?.case ? "Cs" : "Pc";
          
          return elementToKeep === "Cs" ? `${data1?.totalCaseQuantity} ${caseUnitLabel}` : `${data1?.totalPieceQuantity} ${packUnitLabel}`;
        }
        return (
          <p>
            {caseUnitLabel && (
              <>
                {data1?.totalCaseQuantity ?? 0}{" "}
                <span className="CustomAccordian_total_csPcV2">{caseUnitLabel}</span>{" "}
              </>
            )}

            {otherUnitLabel && (
              <>
                , {data1?.totalOtherUnitQuantity ?? 0}{" "}
                <span className="CustomAccordian_total_csPcV2">{otherUnitLabel},</span>{" "}
              </>
            )}

            {packUnitLabel && (
              <>
                , {data1?.totalPieceQuantity ?? 0}{" "}
                <span className="CustomAccordian_total_csPcV2">{packUnitLabel}</span>
              </>
            )}
          </p>
        );

      case "totalQuantitiesFOC_QPS":
        if (tooltip)
          return `${data1?.totalCaseQuantityQpsFoc ?? 0} ${caseUnitLabel + `, `}${
            otherUnitLabel ? 
            `${data1?.totalOtherUnitQuantityQpsFoc ?? 0} ${otherUnitLabel + `, `}`
          : ``}${data1?.totalPieceQuantityQpsFoc ?? 0} ${packUnitLabel}`;
        if(designationEnabled && designation && designationKeys && matchedRole){
          const elementToKeep = matchedRole?.uomAllowed?.case ? "Cs" : "Pc";
          
          return elementToKeep === "Cs" ? `${data1?.totalCaseQuantityQpsFoc ?? 0} ${caseUnitLabel}` : `${data1?.totalPieceQuantityQpsFoc ?? 0} ${packUnitLabel}`;
        }
        return (
          <p>
            {caseUnitLabel && (
              <>
                {data1?.totalCaseQuantityQpsFoc ?? 0}{" "}
                <span className="CustomAccordian_total_csPcV2">
                  {caseUnitLabel},
                </span>{" "}
              </>
            )}

            {otherUnitLabel && (
              <>
                {data1?.totalOtherUnitQuantityQpsFoc ?? 0}{" "}
                <span className="CustomAccordian_total_csPcV2">
                  {otherUnitLabel},
                </span>{" "}
              </>
            )}

            {packUnitLabel && (
              <>
                {data1?.totalPieceQuantityQpsFoc ?? 0}{" "}
                <span className="CustomAccordian_total_csPcV2">
                  {packUnitLabel}
                </span>
              </>
            )}
          </p>
        );
      case "totalDiscount":
        return <div
          className="CustomAccordian_valueV2"
          style={{...meta.customStyles}}
        >
          {meta.currencySymbol}{" "}
          {truncateToTwoDecimals(parseFloat(data1?.couponValue ?? 0) +
            parseFloat(data1?.discountValue ?? 0) +
            parseFloat(data1?.additionalDistributorDiscount ?? 0))}
        </div>
      case "source":
        return <div
                  className="CustomAccordian_valueV2"
                  style={meta.focusField ? { fontSize: "14px" } : undefined}
                >
                  {getOrderSource(data1)}
                </div>
      case "totalConvertedCasesViewPrimaryOMS":
        return <div
                  className="CustomAccordian_valueV2"
                  style={meta.focusField ? { fontSize: "14px" } : undefined}
                >
                       {`${data1?.totalConvertedCasesViewPrimaryOMS ?? 0} ${
                        (data1?.totalConvertedCasesViewPrimaryOMS ?? 0) > 1 ? "Cases" : "Case"}`}
                </div>
      case "totalLoadWeightTonsViewPrimaryOMS":
        return `${truncateToTwoDecimals(data1?.totalWeight ?? 0)} ton`
      case "totalDiscountValue":
        return <div
          className="CustomAccordian_valueV2"
          style={{...meta.customStyles}}
        >
          {meta.currencySymbol}{" "}
          {truncateToTwoDecimals(
            parseFloat(data1?.totalDiscountValue ?? 0)) }
        </div>
      case "totalOrderedQuantities":
        if (tooltip)
          return `${data1?.totalOrderedCases} ${caseUnitLabel + `, `}${
            otherUnitLabel ? 
            `${data1?.totalOrderedOthers} ${otherUnitLabel + `, `}`
          : ``}${data1?.totalOrderedPieces} ${packUnitLabel}`;
        if(designationEnabled && designation && designationKeys && matchedRole){
          const elementToKeep = matchedRole?.uomAllowed?.case ? "Cs" : "Pc";
          
          return elementToKeep === "Cs" ? `${data1?.totalOrderedCases} ${caseUnitLabel}` : `${data1?.totalOrderedPieces} ${packUnitLabel}`;
        }
        return (
          <p style={{...meta.customStyles}}>
            { caseUnitLabel &&
              <>
                {data1?.totalOrderedCases}{" "}
                <span className="CustomAccordian_total_csPcV2">{caseUnitLabel},</span>{" "}
              </>
            }
            {otherUnitLabel && (
              <>
                {data1?.totalOrderedOthers}{" "}
                <span className="CustomAccordian_total_csPcV2">
                  {otherUnitLabel},
                </span>{" "}
              </>
            )}
            { packUnitLabel &&
              <>
                {data1?.totalOrderedPieces}{" "}
                <span className="CustomAccordian_total_csPcV2">{packUnitLabel}</span>
              </>
            }
          </p>
        );
        case "stockExceedingQuantity":
        if (tooltip)
          return `${data1?.stockExceedingCases} ${caseUnitLabel + `, `}${
            otherUnitLabel ? 
            `${data1?.stockExceedingOthers} ${otherUnitLabel + `, `}`
          : ``}${data1?.stockExceedingPieces} ${packUnitLabel}`;
        if(designationEnabled && designation && designationKeys && matchedRole){
          const elementToKeep = matchedRole?.uomAllowed?.case ? "Cs" : "Pc";
          
          return elementToKeep === "Cs" ? `${data1?.stockExceedingCases} ${caseUnitLabel}` : `${data1?.stockExceedingPieces} ${packUnitLabel}`;
        }
        return (
          <p style={{...meta.customStyles}}>
            {data1?.stockExceedingCases}{" "}
            <span className="CustomAccordian_total_csPcV2">{caseUnitLabel},</span>{" "}
            {otherUnitLabel && (
              <>
                {data1?.stockExceedingOthers}{" "}
                <span className="CustomAccordian_total_csPcV2">
                  {otherUnitLabel},
                </span>{" "}
              </>
            )}
            {data1?.stockExceedingPieces}{" "}
            <span className="CustomAccordian_total_csPcV2">{packUnitLabel}</span>
          </p>
        );
         case "totalAvailableQuantity":
        if (tooltip)
          return `${data1?.availableCases} ${caseUnitLabel + `, `}${
            otherUnitLabel ? 
            `${data1?.availableOthers} ${otherUnitLabel + `, `}`
          : ``}${data1?.availablePieces} ${packUnitLabel}`;
        if(designationEnabled && designation && designationKeys && matchedRole){
          const elementToKeep = matchedRole?.uomAllowed?.case ? "Cs" : "Pc";
          
          return elementToKeep === "Cs" ? `${data1?.availableCases} ${caseUnitLabel}` : `${data1?.availablePieces} ${packUnitLabel}`;
        }
        return (
          <p style={{...meta.customStyles}}>
            {data1?.availableCases}{" "}
            <span className="CustomAccordian_total_csPcV2">{caseUnitLabel},</span>{" "}
            {otherUnitLabel && (
              <>
                {data1?.availableOthers}{" "}
                <span className="CustomAccordian_total_csPcV2">
                  {otherUnitLabel},
                </span>{" "}
              </>
            )}
            {data1?.availablePieces}{" "}
            <span className="CustomAccordian_total_csPcV2">{packUnitLabel}</span>
          </p>
        );
        case "totalReplacementAvailable":
        return (
          <ReplacementPopoverCell sku={data1.batchCode} replacements={data1.replacementSkuAvailable} showTotalStock={true}/>
        );
      default:
        return <></>;
    }
  };

  return (
    <div className="CustomAccordianV2">
      <div>

        <div style={{}}>
          <div className="CustomAccordian_detailsV2">
            <div className="CustomAccordian_details_left_containerV2" 
            // style={{gap: metaData1ChunkSize >= 5 ? "0px" : "8px"}}
            >
              <div className="CustomAccordian_details_info_containerV2">
                {metaData1.map((meta: CustomAccordianMetaData, index: number) => {
                  const isLast = index === metaData1.length - 1;
                  return (
                    <React.Fragment>
                      <div className="flex-itemV2">
                        <Tooltip title={meta.label} arrow>
                          <div className="CustomAccordian_labelV2">{meta.label}</div>
                        </Tooltip>
                          <div
                            className="CustomAccordian_valueV2"
                            style={{...meta?.customStyles}}
                            onClick={meta.onClick}
                          >
                            {meta?.render === "Jsx"
                              ? renderCustomJsx(meta)
                              : getNestedValue(
                                  data1,
                                  meta.keys,
                                  meta?.valueType,
                                  meta?.currencySymbol
                                )}
                          </div>
                      </div>

                      {!isLast && (
                        <Divider
                          style={{
                            padding: "5px 0",
                            borderRight: "2px dotted",
                            color: "#DFE2E7",
                            margin: "0 5px",
                            boxSizing: "border-box",
                          }}
                          orientation="vertical"
                          flexItem
                        />
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
            <div>
            {showMoreDetails !== false && (
              <>
              <button className="moreDetails-buttonV2"
                onClick={handleClick}
              >
                More details <KeyboardArrowDownIcon sx={{ width: "15px" }} />
              </button>
              <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              {moreDetails.map((group, gIdx) => (
                <div style={{ padding: "6px 12px" }}>
                  {/* Section title */}
                  <div
                    style={{
                      fontSize: 12,
                      color: "#A1A1A1",
                      fontWeight: 500,
                      marginBottom: 4,
                    }}
                  >
                    {group.title}
                  </div>

                  {/* Divider */}
                  <div
                    style={{
                      borderTop: "1px solid #e0e0e0",
                      margin: "4px 0 8px",
                      width: "100%",
                    }}
                  />

                  {/* Values */}
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
                    {group.items.map((item, idx) => (
                      <MenuItem
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          maxWidth: 130,
                          minWidth: 130,
                          px: 0,
                          py: 0.5,
                          "&:hover": { backgroundColor: "transparent" } // keep menu look clean
                        }}
                        disableRipple
                      >
                        <Tooltip title={String(item.label)} arrow>
                          <span
                            style={{
                              fontSize: 13,
                              color: "#868686",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              maxWidth: "100%",
                            }}
                          >
                            {item.label}
                          </span>
                        </Tooltip>
                        <Tooltip title={String(item.value)} arrow>
                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: 500,
                              color: "#747474",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              maxWidth: "100%",
                              display: "inline-block",
                            }}
                          >
                            {item.value}
                          </span>
                        </Tooltip>
                      </MenuItem>
                    ))}
                  </div>
                </div>
              ))}
            </Menu>
            </>
            )}
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomAccordianV2;
